import { render, staticRenderFns } from "./ShoppingLists.vue?vue&type=template&id=00b19b14&scoped=true"
import script from "./ShoppingLists.vue?vue&type=script&lang=ts"
export * from "./ShoppingLists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b19b14",
  null
  
)

export default component.exports